// ==========================================
// BY ZY — Design Tokens v3
// Match the Glass Morphism reference
// ==========================================

export const TOKENS = {
  colors: {
    bg: {
      primary: '#0a0a0b',
      secondary: '#111113',
      // Subtle top-light gradient
      gradient: 'radial-gradient(ellipse 90% 50% at 50% 0%, #1a1a1e 0%, #0a0a0b 60%)',
    },
    glass: {
      bg: 'rgba(255, 255, 255, 0.04)',
      bgHover: 'rgba(255, 255, 255, 0.065)',
      border: 'rgba(255, 255, 255, 0.09)',
      borderTop: 'rgba(255, 255, 255, 0.15)',   // brighter top edge (light from above)
      borderHover: 'rgba(255, 255, 255, 0.16)',
      highlight: 'rgba(255, 255, 255, 0.05)',
      innerHaze: 'rgba(255, 255, 255, 0.02)',
      shadow: '0 12px 40px rgba(0,0,0,0.55), 0 2px 10px rgba(0,0,0,0.35)',
      blur: '18px',
    },
    text: {
      primary: '#f0f0f2',
      secondary: '#9a9aaa',
      muted: '#52525b',
    },
    glow: {
      soft: 'rgba(220, 220, 230, 0.06)',
      accent: 'rgba(230, 230, 240, 0.10)',
    },
    particles: {
      color: 'rgba(200, 200, 215, 0.7)',
    },
  },
  // Sphere shading — dark opaque 3D look (matching reference)
  sphere: {
    // Specular highlight at ~30% 25% from top-left
    specular: 'rgba(255, 255, 255, 0.30)',
    specularSoft: 'rgba(255, 255, 255, 0.08)',
    // Body colors — very dark with subtle cool undertone
    bodyLight: '#3a3d4a',
    bodyMid: '#252730',
    bodyDark: '#161820',
    bodyEdge: '#0d0e13',
    // Subtle color tints
    tintBlue: '#2a2d3e',
    tintWarm: '#302c28',
    // Shadow
    outerShadow: '0 10px 30px rgba(0,0,0,0.5)',
    innerShadow: 'inset 0 -4px 12px rgba(0,0,0,0.3)',
  },
  animation: {
    duration: {
      fast: 0.2,
      medium: 0.5,
      slow: 1.0,
      cinematic: 1.8,
      particle: 1.4,
      blobDrift: 20,
      haloBreathe: 5,
    },
    ease: {
      premium: [0.25, 0.1, 0.25, 1.0],
      gentle: [0.4, 0.0, 0.2, 1.0],
      out: [0.0, 0.0, 0.2, 1.0],
    },
    scrollThreshold: 80,
  },
  card: {
    borderRadius: '1.25rem',
    backdropBlur: '18px',
  },
};
